// Fixed categorical hues — validated for CVD-safe adjacent contrast (see dataviz skill),
// stepped separately for each theme rather than reusing the light hexes in dark mode.
// Assigned in this order, never cycled or re-sorted by value, across every chart that
// uses it (Dashboard's Spending Breakdown donut, Recurring's payments-by-kind bar, ...).
export const CATEGORICAL_PALETTE = {
  light: ['#2a78d6', '#eb6834', '#1baf7a', '#eda100', '#e87ba4'],
  dark: ['#3987e5', '#d95926', '#199e70', '#c98500', '#d55181'],
}
export const CATEGORICAL_OTHER_COLOR = { light: '#888888', dark: '#706860' }
